var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d00b02"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,3.44c-30.40906,0 -55.04,24.63094 -55.04,55.04c0,25.14156 13.27625,52.16438 26.3375,73.1c13.06125,20.93563 26.1225,35.7975 26.1225,35.7975c0.65844,0.73906 1.59906,1.16906 2.58,1.16906c0.98094,0 1.92156,-0.43 2.58,-1.16906c0,0 13.07469,-15.17094 26.1225,-36.2275c13.04781,-21.05656 26.3375,-48.01219 26.3375,-72.67c0,-30.40906 -24.63094,-55.04 -55.04,-55.04zM86,10.32c26.70031,0 48.16,21.45969 48.16,48.16c0,22.13156 -12.51031,48.44219 -25.2625,69.015c-10.68281,17.24031 -19.72625,28.33969 -22.8975,32.1425c-3.19812,-3.77594 -12.24156,-14.63344 -22.8975,-31.7125c-12.73875,-20.425 -25.2625,-46.77594 -25.2625,-69.445c0,-26.70031 21.45969,-48.16 48.16,-48.16zM86,37.84c-13.26281,0 -24.08,10.81719 -24.08,24.08c0,13.26281 10.81719,24.08 24.08,24.08c13.26281,0 24.08,-10.81719 24.08,-24.08c0,-13.26281 -10.81719,-24.08 -24.08,-24.08zM86,44.72c9.54063,0 17.2,7.65938 17.2,17.2c0,9.54063 -7.65937,17.2 -17.2,17.2c-9.54062,0 -17.2,-7.65937 -17.2,-17.2c0,-9.54062 7.65938,-17.2 17.2,-17.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.19bb045a0a299ca2f4f8e39ba5b015a2.svg";
export { ForwardRef as ReactComponent };